<div class="sn-map__container"></div>
<ng-template cdkPortalOutlet></ng-template>
<ng-content></ng-content>
